<template>
  <div>
    <CRow>
      <CCol>
        <CCard class="bg-style2">
          <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span class="font-weight-bold h6"><CIcon name="cil-tags" size="lg"/>
                <template v-if="caseData">
                  # {{ caseData.taxTd || (caseData._id ? caseData._id.slice(-6) : '') }}
                </template>
                <template v-else>
                  {{ caption }}
                </template>
            </span>
            <div class="card-header-actions" @click="goBack" style="cursor: pointer">
              <CIcon name="cil-x" size="lg" />
            </div>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol>
                <template v-if="caseData">
                  <p class="font-weight-bold mb-0 h5">{{ title }}</p>
                  <p>{{ caseData.description }}</p>
                </template>
                <template v-else>
                  <p>กำลังโหลดข้อมูล...</p>
                </template>
              </CCol>
              <CCol>
                <template v-if="caseData">
                  <!-- แสดง Countup พร้อมสีตาม SLA เมื่อเคสยังไม่ปิด -->
                  <Countup 
                    v-if="shouldShowCountup"
                    :start="countupStartTime" 
                    :name="caseData._id || 'case'"
                    :class="getSLAColor()"
                  />
                  <!-- แสดง dateRange เมื่อปิดเคสแล้ว -->
                  <template v-else>
                    <p class="font-weight-bold text-right mb-0">{{ dateRange }}</p>
                  </template>
                </template>
              </CCol>
            </CRow>
            <CRow v-if="caseData">
              <CCol col="3">
                <CIcon name="cil-contact" size="lg"/> {{ contact }}
              </CCol>
              <CCol col="3" style="cursor: pointer" @click="zoomToCase">
                <CIcon :name="buildingIcon" size="lg"/> {{ address}}
              </CCol>
              <CCol col="3">
                <CIcon name="cil-phone" size="lg"/> {{ phone }}
              </CCol>
              <CCol col="3" class="">
                <CaseControl :case-id="caseData && caseData._id" 
                            @case-opened="handleCaseOpened"
                            @case-closed="handleCaseClosed"/>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow class="mt-4 pt-1">
      <CCol>
        <CRow>
          <CCol col="12" class="mb-4">
            <FoodAssest :item="item" caption="อาหารและอุปกรณ์" :case-id="caseData && caseData._id"/>
          </CCol>

          <CCol col="12" class="mb-4">
            <CarAssest caption="รถรับส่ง" icon="cil-bus-alt" :case-id="caseData && caseData._id" @zoom-to="onZoomToCar" @show-route="onShowRoute"/>
          </CCol>

          <CCol col="12" class="mb-4" v-if="caseData && (isCaseOpened || (caseData.caseManagement && caseData.caseManagement.caseHistory && caseData.caseManagement.caseHistory.length > 0))">
            <CaseHistory 
              :case-data="caseData && caseData.caseManagement ? caseData.caseManagement : {}"
              :case-id="caseData && caseData._id"
              caption="ประวัติการเปิดปิดเคส"
              icon="cil-history"
              @case-opened="handleCaseOpened"
              @case-closed="handleCaseClosed"
              @case-updated="handleCaseUpdated"
            />
          </CCol>
        </CRow>
      </CCol>
      <CCol>
        <GoogleMaps
          ref="googleMaps"
          v-if="hasValidCoordinates()"
          :selected-case-id="caseData && caseData._id"
          :center="mapCenter"
          :route="currentRoute"
        />
        <GoogleMaps 
          ref="googleMaps"
          v-else 
          :selected-case-id="caseData && caseData._id" 
          :center="mapCenter"
          :route="currentRoute"
        />

        <Note 
          class="mb-4"
          :case-id="caseData && caseData._id"   
        />  

      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Swal from 'sweetalert2'
import FoodAssest from '@/projects/components/Util/FoodAssest.vue'
import CarAssest from '@/projects/components/Util/CarAssest.vue'
import GoogleMaps from './GoogleMaps.vue'
import Note from './Note.vue'
import CaseControl from '@/projects/components/Util/CaseControl.vue'
import CaseHistory from '@/projects/components/Util/CaseHistory.vue'
import Countup from '@/projects/components/custom/Countup.vue'

export default {
  name: 'Dashboard2',
  components: {
    FoodAssest,
    CarAssest,
    CaseHistory,
    CaseControl,
    GoogleMaps,
    Note,
    Countup
  },
  props: {
    caption: {
      type: String,
      default: 'รายละเอียดเคส'
    }
  },

  data() {
    return {
      title: '',
      date: '',
      contact: '',
      address: '',
      phone: '',
      isCaseOpened: false,
      mapCenter: null,
      currentRoute: null // สำหรับเก็บ route data สำหรับแสดง polyline
    }
  },

  created() {
    this.onInit();
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    onInit() {
      const caseId = this.$route.query.id;
      if (caseId) {
        this.$store.dispatch("Dashboard2/case", { id: caseId });
      }
      // Start SLA timer เพื่อให้สีเปลี่ยนตามเวลาอัตโนมัติ
      this.$store.dispatch("History/startSlaTimer");
    },

    cleanup() {
      // Stop SLA timer เมื่อ component ถูกทำลาย
      this.$store.dispatch("History/stopSlaTimer");
    },
    onZoomToCar({ lat, lng, zoom, title, plate, label }) {
      if (lat != null && lng != null) {
        // อัปเดต mapCenter
        this.mapCenter = { lat, lng, zoom: zoom || 16 };
        
        // แสดง InfoWindow พร้อม title (ใช้ label ถ้ามี ไม่งั้นใช้ title หรือ title + plate)
        const carTitle = label || (title && plate ? `${title} (${plate})` : title || plate || 'รถ');
        
        // เรียก method ใน GoogleMaps component เพื่อแสดง InfoWindow
        this.$nextTick(() => {
          if (this.$refs.googleMaps) {
            this.$refs.googleMaps.showInfoWindowAt({ lat, lng }, carTitle);
          }
        });
      }
    },

    onShowRoute(routeData) {
      if (routeData && routeData.path && routeData.path.length > 0) {
        this.currentRoute = routeData;
        
        // ซูมแผนที่ให้ครอบคลุมทั้งเส้นทาง
        if (routeData.origin && routeData.destination) {
          this.$nextTick(() => {
            if (window.google && window.google.maps) {
              try {
                const bounds = new window.google.maps.LatLngBounds();
                bounds.extend(routeData.origin);
                bounds.extend(routeData.destination);
                
                // คำนวณ center และ zoom level
                const center = bounds.getCenter();
                const latDiff = Math.abs(routeData.origin.lat - routeData.destination.lat);
                const lngDiff = Math.abs(routeData.origin.lng - routeData.destination.lng);
                const maxDiff = Math.max(latDiff, lngDiff);
                
                // คำนวณ zoom level ที่เหมาะสม
                let zoom = 15;
                if (maxDiff > 1) zoom = 10;
                else if (maxDiff > 0.5) zoom = 11;
                else if (maxDiff > 0.25) zoom = 12;
                else if (maxDiff > 0.1) zoom = 13;
                else if (maxDiff > 0.05) zoom = 14;
                
                this.mapCenter = { 
                  lat: center.lat(), 
                  lng: center.lng(), 
                  zoom: zoom
                };
              } catch (error) {
                console.warn('Error calculating bounds:', error);
                // Fallback: ใช้ center point ระหว่าง origin และ destination
                this.mapCenter = {
                  lat: (routeData.origin.lat + routeData.destination.lat) / 2,
                  lng: (routeData.origin.lng + routeData.destination.lng) / 2,
                  zoom: 13
                };
              }
            } else {
              // Fallback: ใช้ center point ระหว่าง origin และ destination
              this.mapCenter = {
                lat: (routeData.origin.lat + routeData.destination.lat) / 2,
                lng: (routeData.origin.lng + routeData.destination.lng) / 2,
                zoom: 13
              };
            }
          });
        }
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },

    updateDisplayData() {
      if (this.caseData) {
        this.title = this.caseData.type && this.caseData.type.title 
          ? this.caseData.type.title.find(t => t.key === 'th')?.value || 'ไม่ระบุ'
          : 'ไม่ระบุ';
        
        this.date = this.caseData.timeStamps 
          ? this.formatDate(this.caseData.timeStamps) 
          : 'ไม่ระบุ';
        
        this.contact = this.caseData.contact && this.caseData.contact.name 
          ? this.caseData.contact.name 
          : 'ไม่ระบุ';
        
        this.address = this.caseData.location && this.caseData.location.address 
          ? this.caseData.location.address 
          : 'ไม่ระบุ';
        
        this.phone = this.caseData.contact && this.caseData.contact.phone 
          ? this.caseData.contact.phone 
          : 'ไม่ระบุ';
      }
    },

    hasValidCoordinates() {
      return this.caseData && 
             this.caseData.location && 
             this.caseData.location.coordinates && 
             this.caseData.location.coordinates.length === 2;
    },

    handleCaseOpened(data) {
      console.log('Case opened successfully:', data);
      this.isCaseOpened = true;
      this.$store.dispatch("Dashboard2/case", { id: this.$route.query.id });
    },

    async handleCaseClosed(data) {
      console.log('Case closed successfully:', data);
      this.isCaseOpened = false;
      await new Promise(r => setTimeout(r, 200));
      await this.$store.dispatch("Dashboard2/case", { id: this.$route.query.id });
      console.log(this.caseData?.caseManagement?.caseHistory);
    },

    handleCaseUpdated() {
      this.$emit('case-updated');
    },

    zoomToCase() {
      try {
        const loc = this.caseData?.location;
        const coords = loc?.coordinates;
        if (Array.isArray(coords) && coords.length === 2) {
          const [lng, lat] = coords;
          const caseTitle = this.title || 'เหตุการณ์';
          
          // อัปเดต mapCenter
          this.mapCenter = { lat, lng, zoom: 16 };
          
          // เรียก method ใน GoogleMaps component เพื่อแสดง InfoWindow
          this.$nextTick(() => {
            if (this.$refs.googleMaps) {
              this.$refs.googleMaps.showInfoWindowAt({ lat, lng }, caseTitle);
            }
          });
        } else {
          Swal.fire({ icon: 'info', title: 'ไม่พบตำแหน่ง', text: 'เหตุการณ์นี้ยังไม่มีพิกัด' });
        }
      } catch (err) {
        console.error('zoomToCase error', err);
      }
    },

    formatDateThai(date) {
      if (!date) return '';
      return moment(date).locale('th').add(543, 'year').format('D MMM YYYY HH.mm น.');
    },

    getCaseStartEnd() {
      console.log('CASE HISTORY (in getCaseStartEnd):', this.caseData?.caseManagement?.caseHistory);
      const cm = this.caseData && this.caseData.caseManagement;
      let start = this.caseData && this.caseData.timeStamps ? this.caseData.timeStamps : null;

      if (cm && Array.isArray(cm.caseHistory)) {
        const opened = cm.caseHistory.find(h => (h.action || '').toLowerCase() === 'opened');
        if (opened) {
          start = opened.timestamp || opened.time || opened.date || opened.createdAt || opened.at || start;
        }
      }
      
      let end = null;
      if (cm && Array.isArray(cm.caseHistory)) {
        const closed = [...cm.caseHistory]
          .reverse()
          .find(h => ['closed','close','case_closed'].includes((h.action || '').toLowerCase()));
        if (closed) {
          end = closed.timestamp || closed.time || closed.date || closed.createdAt || closed.closedAt || closed.at || null;
        }
      }
      if (!end && cm && cm.isOpen === false) {
        end = cm.closedAt || cm.updatedAt || cm.closeTime || null;
      }

      return { start, end };
    },

    buildDateRangeText() {
      const { start, end } = this.getCaseStartEnd();
      // แสดง dateRange เฉพาะเมื่อปิดเคสแล้ว (มี end time)
      if (!end) return '';
      const startText = this.formatDateThai(start);
      const endText = this.formatDateThai(end);
      return `${startText} - ${endText}`;
    },

    // เช็คว่าเคสปิดแล้วหรือไม่
    isCaseClosed() {
      if (!this.caseData?.caseManagement?.caseHistory || 
          this.caseData.caseManagement.caseHistory.length === 0) {
        return false;
      }
      const lastAction = this.caseData.caseManagement.caseHistory[
        this.caseData.caseManagement.caseHistory.length - 1
      ];
      return lastAction.action === 'closed';
    },

    // แปลง level object เป็น string
    getLevelText() {
      if (!this.caseData?.level) return '';
      if (typeof this.caseData.level === 'string') {
        return this.caseData.level;
      }
      if (this.caseData.level.title && Array.isArray(this.caseData.level.title)) {
        return this.caseData.level.title.find(t => t.key === 'th')?.value || '';
      }
      return '';
    },

    // คำนวณสีตาม SLA เหมือนใน history.vue
    getSLAColor() {
      if (!this.caseData) return 'text-dark';

      // ใช้เวลาเดียวกันกับ history.vue (timeStamps)
      const startTime = moment(this.caseData.timeStamps || this.caseData.date || new Date());
      const elapsedMinutes = this.currentTime.diff(startTime, 'minutes');

      const levelText = this.getLevelText();
      let slaLimit = 15;
      if (levelText === 'ระดับกลาง') slaLimit = 20;
      else if (levelText === 'ระดับสูง') slaLimit = 25;

      if (elapsedMinutes > slaLimit) {
        return 'text-danger';
      } else if (elapsedMinutes > slaLimit * 0.8) {
        return 'text-warning';
      } else {
        return 'text-dark';
      }
    }
  },

  computed: {
    ...mapGetters({
      caseData: 'Dashboard2/case',
      timerValue: 'History/timerValue',
      slaTimer: 'History/slaTimer',
    }),

    buildingIcon() {
      const text = this.caseData?.location?.address || this.caseData?.description || '';
      return (text.includes('แม่ฟ้าหลวง') || text.includes('Mae FahLuang')) 
        ? 'cil-institution' 
        : 'cil-building';
    },

    dateRange() {
      if (!this.caseData) return '';
      return this.buildDateRangeText();
    },

    // เช็คว่าควรแสดง Countup หรือไม่ (ถ้ายังไม่เปิดเคส หรือเปิดแล้วแต่ยังไม่ปิด)
    shouldShowCountup() {
      if (!this.caseData) return false;
      
      const { end } = this.getCaseStartEnd();
      
      // ถ้ามี end time แสดงว่าเคสปิดแล้ว ให้แสดง dateRange แทน
      // ถ้ายังไม่ปิดเคส (ไม่มี end time) ให้แสดง Countup
      return !end;
    },

    // หาเวลาเริ่มต้นสำหรับ Countup (ใช้เวลาเดียวกับ history.vue)
    countupStartTime() {
      if (!this.caseData) return new Date();
      
      // ใช้ timeStamps เหมือนใน history.vue (item.date)
      return this.caseData.timeStamps 
        ? new Date(this.caseData.timeStamps) 
        : new Date();
    },

    // เพิ่ม computed property เพื่อ trigger reactivity เมื่อ timerValue เปลี่ยน
    currentTime() {
      // ใช้ timerValue เพื่อ trigger reactivity
      this.timerValue;
      return moment();
    }
  },

  watch: {
    caseData: {
      handler(newVal, oldVal) {
        console.log('CASE UPDATED:', newVal?.caseManagement?.caseHistory);
        this.updateDisplayData();
        this.$emit('case-changed', newVal);

        if (newVal && newVal.caseManagement) {
          const cm = newVal.caseManagement;

          if (typeof cm.isOpen === 'boolean') {
            this.isCaseOpened = cm.isOpen;
          } else if (Array.isArray(cm.caseHistory) && cm.caseHistory.length > 0) {
            const lastAction = cm.caseHistory[cm.caseHistory.length - 1].action;
            this.isCaseOpened = (lastAction === 'opened');
          } else {
            this.isCaseOpened = false;
          }
        }

        if (newVal && oldVal &&
            JSON.stringify(newVal.caseManagement) !== JSON.stringify(oldVal.caseManagement)) {
          this.$store.dispatch("Dashboard/reports", {});
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 1rem;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: modalSlideIn 0.3s ease-out;
  border: none;
}

@keyframes modalSlideIn {
  from { opacity: 0; transform: translateY(-30px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.modal-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  min-height: 60px;
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
}

.modal-title {
  margin: 0;
  font-weight: bold;
  font-size: 1rem;
  flex: 1;
  margin-right: 4rem;
  display: flex;
  align-items: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.close {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  color: white;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-left: auto;
}

.close:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.modal-footer {
  padding: 1.25rem 1.5rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  align-items: center;
  background: white;
}

.form-group {
  margin-bottom: 1.25rem;
  background: white;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;
}

.form-group label {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #495057;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-control {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #e9ecef;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  transition: all 0.2s ease;
  background: #f8f9fa;
}

.form-control:focus {
  outline: none;
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
  background: white;
}

.form-control::placeholder {
  color: #6c757d;
  opacity: 0.7;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  transition: all 0.2s;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-success:hover {
  background-color: #218838;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover {
  background-color: #c82333;
}

/* ควบคุมขนาดปุ่ม CANCEL และ SUBMIT */
.text-right .btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  line-height: 1.2;
  border-radius: 20px;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.text-right .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.text-right .btn.btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
  background-color: transparent;
}

.text-right .btn.btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}

.text-right .btn.btn-outline-success {
  border-color: #28a745;
  color: #28a745;
  background-color: transparent;
}

.text-right .btn.btn-outline-success:hover {
  background-color: #28a745;
  color: white;
}

.text-right .btn .c-icon {
  font-size: 0.75rem;
  margin-right: 0.2rem;
  vertical-align: middle;
}

.text-right .btn span {
  font-size: 0.75rem;
  font-weight: 600;
  vertical-align: middle;
}

.modal-btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  line-height: 1.2;
  border-radius: 20px;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 1px solid;
}

.modal-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modal-btn.btn-outline-secondary {
  border-color: #6c757d;
  color: #6c757d;
  background-color: transparent;
}

.modal-btn.btn-outline-secondary:hover {
  background-color: #6c757d;
  color: white;
}

.modal-btn.btn-outline-success {
  border-color: #28a745;
  color: #28a745;
  background-color: transparent;
}

.modal-btn.btn-outline-success:hover {
  background-color: #28a745;
  color: white;
}

.modal-btn.btn-outline-danger {
  border-color: #dc3545;
  color: #dc3545;
  background-color: transparent;
}

.modal-btn.btn-outline-danger:hover {
  background-color: #dc3545;
  color: white;
}
</style>
